export const HAGAI_TESTIMONY = {
  title: 'Contractor testimony',
  subtitle: 'Hagai — Austin Remodel Pro build partner',
  items: [
    {
      id: 1,
      topic: 'Project Overview / What Made It Different',
      question:
        'If you can just give a quick overview of the project and then what made the build different from a typical single-family home project?',
      answer: [
        'Yeah, it was from the get-go. The planning of the project was basically conventional planning for a regular building: foundation, framing, and then taking into consideration the rough-in, the sheathing, and all of the other things that you have to account for. Those things usually come one after another, and it takes a long time to get them done.',
        'When I ran into Construx, they solved a lot of those issues, or saved me a lot of time in planning, because the framing came together with all of this. It was already done. The framing was done, and the rough-in access was pretty much opened up for us, which made it really easy for us to work.',
        'And the sheathing part was solved. That is a lot of time and a lot of moving parts.',
      ],
      highlights: [
        'it takes a long time to get them done',
        'saved me a lot of time in planning',
        'The framing was done',
        'rough-in access was pretty much opened up for us',
        'the sheathing part was solved',
        'a lot of time and a lot of moving parts',
      ],
    },
    {
      id: 2,
      topic: "Owner's Goals for the ADU",
      question:
        "What were the owner's goals for adding the ADU, and how did those goals shape your approach?",
      answer: [
        "The owner's goal for the ADU was basically to build some kind of unit in the back that he could use either as an Airbnb, a small ADU for his family, or for whoever would be buying or using the house. The idea was to create more value for the property. In that respect, Construx filled all those needs.",
      ],
      highlights: ['create more value for the property', 'Construx filled all those needs'],
    },
    {
      id: 3,
      topic: 'Customer Response to New Technology',
      question:
        'As a contractor, how did you communicate the new technology to your customer? Did he ask? Did he care?',
      answer: [
        'He was actually trusting me 100% on that.',
        'My sales point was that we were going to save a lot of time. I was pretty stressed on time, and I told him we were going to save a lot of time and it was going to look great.',
        'Honestly, he is more than happy.',
      ],
      highlights: ['save a lot of time', 'more than happy'],
    },
    {
      id: 4,
      topic: 'Construction Challenges / Site Conditions / Sequencing',
      question:
        'What were the biggest construction challenges on this project, from site conditions to sequencing, and how were they solved?',
      answer: ['The property challenge was space.'],
      highlights: ['The property challenge was space.'],
    },
    {
      id: 5,
      topic: 'How Construx Solved Those Challenges',
      question: 'How did Construx help solve some of those challenges?',
      answer: [
        'It was exactly the size that we needed. It matched exactly what we had available there.',
        'I own a concrete company, so when the Structural Lead told me we needed to leave space for the building and make the foundation exactly for that, I poured the concrete exactly for that, and it solved the problem.',
      ],
      highlights: [
        'exactly the size that we needed',
        'poured the concrete exactly for that, and it solved the problem',
      ],
    },
    {
      id: 6,
      topic: '550 sq. ft. Design Basis',
      question: 'So it sounds like it is a good design basis for the 550-square-foot model.',
      answer: ['It is perfect for that. It is exactly the size for everything there.'],
      highlights: ['perfect for that', 'exactly the size for everything there'],
    },
    {
      id: 7,
      topic: 'Planning to Execution',
      question: 'How did using Construx affect your ability to move from planning into execution?',
      answer: [
        'From planning, it was perfect because we used Construx to adjust the plans that we already had. Or we could build it based on the plans Construx gives for the units you offer. It was very easy to convert. Like I told you and the Structural Lead, it took us maybe two days to finish it.',
        'Then we submitted. The response from the city was amazing. They took it in and approved it right away. There were no revisions that we had to do to the plans.',
      ],
      highlights: [
        'maybe two days to finish it',
        'approved it right away',
        'no revisions that we had to do to the plans',
      ],
    },
    {
      id: 8,
      topic: 'Rework / Field Changes / Uncertainty',
      question:
        'Were there any parts of the build where Construx helped reduce rework, field changes, or uncertainty on the project?',
      answer: [
        'Everything worked. Like I said, it was streamlined. I do not know if I got lucky on that project, but it was pretty streamlined. Everything worked really smoothly there.',
        'There was no need for any rework. We built it, put it together, and it was done.',
        'Looking back, the one thing we had to make adjustments on was the roofing area and the soffit. We had to adjust a little bit, but that was it.',
      ],
      highlights: [
        'streamlined',
        'no need for any rework',
        'built it, put it together, and it was done',
      ],
    },
    {
      id: 9,
      topic: 'What Came Noticeably Easier',
      question:
        'Looking back, what part of the construction process came noticeably easier compared to a typical project?',
      answer: [
        'The framing. The sheathing. The cavities gave us easy access to do the rough-in. That was basically everything there.',
        'Like I said, the only challenge we had, and it was not a real challenge, was adjusting the roofing based on the structure. Because we did not build the roof from scratch. It came ready, so we had to adjust it. That is the only challenge I see that we had: the roof adjustment.',
      ],
      highlights: ['The framing. The sheathing.', 'easy access to do the rough-in', 'It came ready'],
    },
    {
      id: 10,
      topic: 'Coordination of Trades, Inspections, and Scheduling',
      question:
        'This project included multiple structures and separate utility considerations. How did you coordinate trades, inspections, and scheduling?',
      answer: [
        'We had the system built with the framing done and the windows coordinated. It was basically calling the trades to do the rough-in. We made sure all the plumbing was in the right spaces and right spots based on the unit.',
        'The coordination was pretty much just doing the rough-in. With the MEP, the plumbing and electrical were pretty much what you see and what you have there. With plumbing, of course, there is drainage. But mechanical, you can pretty much put it anywhere you want. There is no limitation there.',
        'The only thing that really needed to be coordinated was the plumbing. Electrical was not a problem.',
      ],
      highlights: ['framing done and the windows coordinated', 'Electrical was not a problem'],
    },
    {
      id: 11,
      topic: 'Communication Between Field Team, Subcontractors, and Stakeholders',
      question:
        'Did Construx improve communication between the field team, subcontractors, and stakeholders? If so, how?',
      answer: [
        'Definitely, because when the building was built, everything was pretty much open. Everybody saw what they needed to do. It was easy to communicate on that.',
        'There was a thread between me, the Structural Lead, and the engineer we had before. They exchanged information between them, and that was ready. He submitted the plans after two days, and we took it from there.',
      ],
      highlights: ['everything was pretty much open', 'submitted the plans after two days'],
    },
    {
      id: 12,
      topic: 'Material Planning / Procurement Timing / Avoiding Delays',
      question:
        'How did the platform influence material planning, procurement timing, or avoiding delays?',
      answer: [
        'Pretty much that: no need to order all the sheathing materials. It was faster and easier in that sense.',
        'When I order materials for framing, it takes a big list of materials that I need to order. This made it shorter and faster.',
      ],
      highlights: ['no need to order all the sheathing materials', 'shorter and faster'],
    },
    {
      id: 13,
      topic: 'Operational Bottlenecks',
      question:
        'What operational bottlenecks were you dealing with before using Construx, or what bottlenecks did it make better compared with a traditional project?',
      answer: [
        'That is exactly it. When you have a lot of moving parts, and people are building the framing on site, you get mismatches and mistakes by the trades and the people working there.',
        'Here, having the unit built with precision-cut parts eliminated those mistakes, and everything was pretty much accurate.',
        'That is a big thing. It was built exactly to the size that we needed. Some adjustment needed to be done, but it was very minor. Things were very easy to fix in the field. It was very easy to work with.',
        'Fewer mistakes happen on site when the system comes prebuilt or precut. With traditional framers, they can miss things required by the plans. But when it comes like that, prebuilt or precut, it pretty much eliminated all of that.',
      ],
      highlights: [
        'a lot of moving parts',
        'precision-cut parts eliminated those mistakes',
        'built exactly to the size that we needed',
        'very easy to work with',
        'eliminated all of that',
      ],
    },
    {
      id: 14,
      topic: 'Schedule Predictability / Crew Efficiency',
      question: 'How did Construx affect schedule predictability and crew efficiency?',
      answer: [
        'The material came on site. It was three days for us to work on that. That was pretty much it.',
        'With a traditional project, you have to bring the guys on site and people have to work there, and there is the unknown of when they are going to finish the framing. Here, you know exactly when it is going to start and end.',
      ],
      highlights: ['three days for us to work on that', 'you know exactly when it is going to start and end'],
    },
    {
      id: 15,
      topic: 'Administrative Workload / Reporting / Visibility',
      question:
        'Did you notice any changes in administrative workload, reporting, or project visibility with the customer or your team compared with a traditional project?',
      answer: ['Not more than regular framing. It was less, if anything.'],
      highlights: ['It was less, if anything'],
    },
    {
      id: 16,
      topic: 'Surprises Once Underway',
      question: 'Was there anything that surprised you about the platform once the project got underway?',
      answer: [
        'First of all, the strength of the building, of the unit, once it was put together. The strength and integrity surprised me the most.',
        'I was not expecting it to be that strong. With traditional framing, everything kind of moves when you shake it. There was no movement there. It was pretty sturdy, and that surprised me the most. It was pretty stable.',
      ],
      highlights: ['strength and integrity surprised me the most', 'no movement there', 'pretty stable'],
    },
    {
      id: 17,
      topic: 'One Improvement',
      question:
        'If you could add or improve one thing in Construx based on this build, what would it be?',
      answer: [
        'The option to have more customizability in the models is the thing I would improve.',
      ],
      highlights: ['more customizability in the models'],
    },
    {
      id: 18,
      topic: 'What He Would Tell Another Contractor',
      question:
        'If another contractor were considering Construx for a similar ADU or infill development project, what would you tell them?',
      answer: [
        'I would give them those points: the speed, especially if they are investors or people who want to have their project done fast. Everybody wants their project done fast. There is no question about it.',
        'That would be the best selling point: it is faster, stronger, easy to build, and easy to work with. From the client perspective or the GC perspective, those are good points because it is easier for the GC to do the MEP, and the client has a shorter time with people on their property.',
      ],
      highlights: [
        'Everybody wants their project done fast',
        'faster, stronger, easy to build, and easy to work with',
        'shorter time with people on their property',
      ],
    },
    {
      id: 19,
      topic: 'One-Sentence Delivery Change',
      question: 'In one sentence, how did Construx change the way your team delivered this project?',
      answer: [
        'It was an investment in technology for us, coming from traditional framing. It was something new that we discovered, and it made our project easier to work with. It made things easier inside.',
      ],
      highlights: ['made our project easier to work with', 'made things easier inside'],
    },
  ],
};
